import { render, staticRenderFns } from "./exportFile.vue?vue&type=template&id=53d3b964&scoped=true&"
import script from "./exportFile.vue?vue&type=script&lang=js&"
export * from "./exportFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3b964",
  null
  
)

export default component.exports